module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagebreak"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a27d60d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/BlockPagebreak.vue
// module id = 661
// module chunks = 0